import { Number, Record, Static, String } from "runtypes";

export const SurveyWrittenResponseResponseRuntype = Record({
  name: String,
  response: String,
  surveyQuestionId: Number,
  surveyResponseId: Number,
});

export interface ISurveyWrittenResponseResponse
  extends Static<typeof SurveyWrittenResponseResponseRuntype> {}



// WEBPACK FOOTER //
// ./src/services/ISurveyWrittenResponseResponse.ts